const Mail = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0"
    y="0"
    enableBackground="new 0 0 14 14"
    version="1.1"
    viewBox="0 0 14 14"
    xmlSpace="preserve"
  >
    <g fill="#030104">
      <path d="M7 9L5.268 7.484.316 11.729c.18.167.423.271.691.271h11.986c.267 0 .509-.104.688-.271L8.732 7.484 7 9z" />
      <path d="M13.684 2.271A1.007 1.007 0 0012.993 2H1.007c-.267 0-.509.104-.689.273L7 8l6.684-5.729z" />
      <path d="M0 2.878L0 11.186 4.833 7.079z" />
      <path d="M9.167 7.079L14 11.186 14 2.875z" />
    </g>
  </svg>
);

export default Mail;
